// src/pages/AboutPage.jsx
import Footer from "../footer";
import "./css/contact.css";
import { Helmet } from "react-helmet";


import ContactSection1 from "./subpages/contact/contact1";

function ContactPage() {
  return (
    <div className="contact-content">
      <Helmet>
        <title>Contacto</title>
        <meta name="description" content="Description of your page for SEO" />
      </Helmet>
      <ContactSection1 />
      <Footer isScrollable={false} />
    </div>
  );
}

export default ContactPage;